// http://kazupon.github.io/vue-i18n/en/messages.html

const requireLang = require.context(
  '@/lang',
  true,
  /\.json$/
)

const messages = {}

for (const file of requireLang.keys()) {
  if (file === './index.js') continue

  const path = file.replace(/(\.\/|\.json$)/g, '').split('/')

  path.reduce((o, s, i) => {
    if (o[s]) return o[s]

    o[s] = i + 1 === path.length
      ? requireLang(file)
      : {}

    return o[s]
  }, messages)
}
//custom translation
/*const requireLangComponents = require.context(
  '@/components/modules',
  true,
  /\.json$/
)
for (const file of requireLangComponents.keys()) {
  if (!file.includes('locale') || !file.includes('.json')) continue
  const path = file.replace(/(\.\/|\.json$)/g, '').split('/')
  if (!messages[path[2]]) messages[path[2]] = {}
  messages[path[2]][path[0]] = requireLangComponents(file)
}
*/

export default messages

/*export default {
  welcome: 'Welcome'
}*/
